import { render, staticRenderFns } from "./WCompaniesList.vue?vue&type=template&id=27a8bc55&"
import script from "./WCompaniesList.vue?vue&type=script&lang=ts&"
export * from "./WCompaniesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports